const messages = {
  title: "Cenniki i broszury produktowe",
  title_media: "Cenniki i broszury produktowe",
  description:
    "Pobierz tutaj najnowsze broszury i ulotki dotyczące opon Bridgestone i Firestone do samochodów osobowych, SUV-ów i dostawczych.",
  short_description:
    "Tutaj znajdziesz materiały do mediów społecznościowych, in-store TV i nie tylko.",
  mediaCategories: {
    products: "Produkty",
    brand_and_solutions: "Marka i rozwiązania",
    season_and_promotions: "Sezon i promocje",
    format: "Format",
    cars_and_vans: "Samochody osobowe, SUV i dostawcze",
    truck_and_buses: "Ciężarowe i autobusy",
    motorcycle: "Motocykle",
    agriculture: "Rolnictwo",
    construction_machinery: "Maszyny budowlane",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiały",
    brochures: "Broszury produktowe",
    price_list: "Cenniki",
    materials: "Materiały",
    video_in_store: "Wideo z napisami",
    video_online: "Wideo bez napisów",
    video: "Wideo",
    banner_website: "Baner",
    banner_social_media: "Media społecznościowe",
    logos: "Logos",
    summer: "Lato",
    winter: "Zima",
    all_season: "Całoroczne",
    promotions: "Promocje",
    price: "Pricat",
  },
  mediasPage: {
    title: "BIBLIOTEKA MEDIÓW",
    description:
      "Witamy w sekcji mediów poświęconej   \n" +
      "produktom Bridgestone i Firestone.  \n <br> <br>" +
      "Odkryjesz wizualizacje produktów,   \n" +
      "logotypy, a także szeroki wybór   \n" +
      "banerów, filmów i materiałów cyfrowych   \n" +
      "do wykorzystania na swojej stronie internetowej lub w   \n" +
      "mediach społecznościowych.  ",
    bDrive: {
      title: "Zdjęcia produktów",
      description:
        "Aktualne obrazy   \n" +
        "można pobrać   \n" +
        "z naszego portalu B-\n" +
        "DRIVE.  ",
    },
  },
  buttons: {
    media: "ODKRYJ",
  },
  searchMedia: "Wpisz słowo kluczowe",
  searchResults: "Wyniki wyszukiwania",
};

export default {
  messages,
};
